import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import SeriesLineItem from './SeriesLineItem';
import moment from 'moment';
import Skeleton from 'shared/Skeleton';
import Translation from '@checkout-s/Translation';
import { DateTimeFormatters } from '@showclix-shared-intl';
import Button from 'shared/Button';

const { weekDayMonthDayYearShort } = DateTimeFormatters;

export default class ListDatePicker extends Component {
    componentDidMount() {
      this.props.calendarView()
    }

    onChangeDate = () => {
      this.props.setIsDateChanging(true);
      this.props.changeDateInternal();
    }

    getEventTime = event => {
      return event ? this.props.getEventTimeFormatted(event.time, event.endTime) : null;
    };

    getSelectedEventTime = () => {
      const id = this.props.selectedChildEvent;
      return Object
        .values(this.props.eventTimes)
        .flat()
        .find(({ id: eventTimeId }) => eventTimeId == id) || null;
    };

    getDateString = () => {
      if (!this.props.selectedDayDate) return undefined;

      const selectedEventTime = this.getSelectedEventTime();

      const eventTime = this.getEventTime(selectedEventTime);

      const dateString = weekDayMonthDayYearShort(this.props.locale, this.props.selectedDayDate);

      return `${dateString}, ${eventTime}`
    }

    render() {
        const dateString = this.getDateString();

        return (
            <div className="list-date-picker">
                <div className="tickets__datepicker">
                    {this.props.collapsed && (
                        <div className="picker__header">
                            <i className='icon-calendar' aria-hidden="true" />
                            <h3 className="picker__header-title">
                                {dateString || <Translation>{'checkout__select_date'}</Translation>}
                            </h3>
                            {!this.props.isDateChanging && (
                              <Button
                                className="button--clear header__action-button"
                                onClick={this.onChangeDate}
                                type="button"
                              >
                                <Translation>{'checkout__change_date'}</Translation>
                              </Button>
                            )}
                        </div>
                    )}
                    {!this.props.collapsed && this.renderEvents()}
                    {this.props.loading &&
                        <Fragment>
                            <div className="card-group">
                                <div className="card">
                                    <Skeleton height="13px" width="166px" />
                                </div>
                                <div className="card">
                                    <Skeleton height="10px" width="70px" />
                                </div>
                                <div className="card">
                                    <Skeleton height="10px" width="100px" />
                                </div>
                            </div>
                            <div className="card-group">
                                <div className="card">
                                    <Skeleton height="13px" width="166px" />
                                </div>
                                <div className="card">
                                    <Skeleton height="10px" width="70px" />
                                </div>
                                <div className="card">
                                    <Skeleton height="10px" width="100px" />
                                </div>
                            </div>
                            <div className="card-group">
                                <div className="card">
                                    <Skeleton height="13px" width="166px" />
                                </div>
                                <div className="card">
                                    <Skeleton height="10px" width="70px" />
                                </div>
                                <div className="card">
                                    <Skeleton height="10px" width="100px" />
                                </div>
                            </div>
                        </Fragment>
                    }
                </div>
            </div>
        );
    }

    onClick = (event) => (id, info) => {
      this.props.setSelectedDate(new Date(event.time));
      this.props.onEventSelected(id, info);
    }

    renderEvents = () => {
        var firstDate;
        return Object.keys(this.props.eventTimes).map((date, i) => {
            if (i === 0){ firstDate = date;}
            const firstAvailableItem = this.props.eventTimes[firstDate].find(times => times.eventStatus === 'on_sale')?.id;
            return <fieldset className="list-date-picker__fieldset" key={i}>
                <legend className="sr-only"><Translation interpolation={{datetime:moment(date).format('ddd[.] MMM D[,] YYYY')}}>{'checkout__ticket_for'}</Translation> </legend>
                <div className="card-group"  role="radiogroup" aria-labelledby={`series-listing-group_${i}`}>
                    <div className="card">
                        <span className="list-date-picker__card-date">
                            <time dateTime={moment(date).format('ddd[.] MMM D[,] YYYY')}>{moment(date).format('dddd[,] MMM D[,] YYYY')}</time>
                        </span>
                    </div>
                    {this.props.eventTimes[date].map((event, j) => {
                        return <SeriesLineItem
                            key={'' + i + j}
                            label={i}
                            time={event.time}
                            endTime={event.endTime}
                            id={event.id}
                            onClick={this.onClick(event)}
                            selected={this.props.selectedChildEvent === Number(event.id)}
                            eventStatus={event.eventStatus}
                            showSoldOut={this.props.showSoldOut}
                            eventInventory={+event.inventory}
                            locale={this.props.locale}
                            hasPresale={event.hasPresale}
                            autoFocus={event.id === firstAvailableItem}
                            seriesChildAdditionalInfo={event.childEventAdditionalInfo}
                        />
                    })}
                </div>
            </fieldset>
        });

    }

    showMenu = () => {
        this.setState({showMenu: true});
    }

    hideMenu = () => {
        this.setState({showMenu: false});
    }
}

ListDatePicker.propTypes = {
    eventTimes: PropTypes.object,
    loading: PropTypes.bool,
    selectedChildEvent: PropTypes.oneOfType([PropTypes.string,PropTypes.number]),
    showSoldOut: PropTypes.bool,
    onEventSelected: PropTypes.func.isRequired,
};
